
import '../../../../assets/css/screens/admin/dashboard/admincustomer/AdminCustomer.css';

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Eye, Ban, AlertTriangle } from 'lucide-react';


const REPORTED_CUSTOMERS = [
  {
    id: 1,
    initials: 'BS',
    name: 'Bilal Shah',
    email: 'bilal@gmail.com',
    reportedBy: 'Ali Electrician',
    reason: 'Abusive language and refused to pay after service...',
    reports: 4,
    status: 'Blocked',
    color: '#3b82f6'
  },
  {
    id: 2,
    initials: 'ZM',
    name: 'Zain Malik',
    email: 'zain@gmail.com',
    reportedBy: 'Usman Plumber',
    reason: 'Provided fake address and wasted time...',
    reports: 2,
    status: 'Under Review',
    color: '#06b6d4'
  },
  {
    id: 3,
    initials: 'HR',
    name: 'Hamza Raza',
    email: 'hamza@gmail.com',
    reportedBy: 'Hassan AC Expert',
    reason: 'Harassment and threatening behavior...',
    reports: 3,
    status: 'Under Review',
    color: '#10b981'
  },
  {
    id: 4,
    initials: 'FS',
    name: 'Farhan Saeed',
    email: 'farhan@gmail.com',
    reportedBy: 'Kashif Painter',
    reason: 'Repeatedly cancels bookings at last minute...',
    reports: 5,
    status: 'Warning Issued',
    color: '#8b5cf6'
  },
  {
    id: 5,
    initials: 'IA',
    name: 'Imran Ali',
    email: 'imran@gmail.com',
    reportedBy: 'Kamran Cleaner',
    reason: 'Payment dispute - claims service was not completed...',
    reports: 1,
    status: 'Under Review',
    color: '#f97316'
  }
];

const TABS = ['All', 'Under Review', 'Warning Issued', 'Blocked'];

const STATUS_COLORS = {
  'Blocked': { bg: '#fee2e2', color: '#dc2626' },
  'Under Review': { bg: '#fef3c7', color: '#f59e0b' },
  'Warning Issued': { bg: '#dbeafe', color: '#3b82f6' }
};

const AdminCustomers = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [customers, setCustomers] = useState(REPORTED_CUSTOMERS);

  const filteredCustomers = customers.filter(customer => {
    const matchesTab = activeTab === 'All' || customer.status === activeTab;
    const matchesSearch = 
      customer.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      customer.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      customer.reportedBy.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesTab && matchesSearch;
  });

  const handleViewDetails = (customerId) => {
    navigate(`/admin/customer-report/${customerId}`);
  };

  const handleBlockCustomer = (customerId) => {
    setCustomers(prev => prev.map(c => 
      c.id === customerId ? { ...c, status: 'Blocked' } : c
    ));
    // Add API call here to block customer
    console.log('Blocked customer:', customerId);
  };

  return (
    <div className="reported-customers-page">
      
      {/* Header */}
      <div className="rc-header">
        <div>
          <h2 className="rc-title">Reported Customers</h2>
          <p className="rc-subtitle">
            <AlertTriangle size={14} />
            {filteredCustomers.length} customers reported by service providers
          </p>
        </div>
        
        {/* Search */}
        <div className="rc-search">
          <Search size={18} className="rc-search-icon" />
          <input
            type="text"
            className="rc-search-input"
            placeholder="Search customers..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      {/* Tabs */}
      <div className="rc-tabs">
        {TABS.map(tab => (
          <button
            key={tab}
            className={`rc-tab ${activeTab === tab ? 'rc-tab--active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Desktop Table */}
      <div className="rc-table-desktop">
        <div className="rc-table-header">
          <div className="col-customer">Customer</div>
          <div className="col-reported-by">Reported By</div>
          <div className="col-reason">Reason</div>
          <div className="col-reports">Reports</div>
          <div className="col-status">Status</div>
          <div className="col-actions">Actions</div>
        </div>

        {filteredCustomers.map((customer, index) => (
          <div 
            key={customer.id} 
            className="rc-table-row"
            style={{ animationDelay: `${index * 0.05}s` }}
          >
            <div className="col-customer">
              <div className="rc-avatar" style={{ backgroundColor: customer.color }}>
                {customer.initials}
              </div>
              <div className="rc-customer-info">
                <div className="rc-customer-name">{customer.name}</div>
                <div className="rc-customer-email">{customer.email}</div>
              </div>
            </div>
            
            <div className="col-reported-by">
              {customer.reportedBy}
            </div>
            
            <div className="col-reason">
              {customer.reason}
            </div>
            
            <div className="col-reports">
              <span className="rc-reports-badge">{customer.reports}</span>
            </div>
            
            <div className="col-status">
              <span 
                className="rc-status-badge"
                style={{
                  backgroundColor: STATUS_COLORS[customer.status]?.bg,
                  color: STATUS_COLORS[customer.status]?.color
                }}
              >
                {customer.status}
              </span>
            </div>
            
            <div className="col-actions">
              <button 
                className="rc-action-btn rc-action-btn--view"
                onClick={() => handleViewDetails(customer.id)}
                title="View Details"
              >
                <Eye size={16} />
              </button>
              <button 
                className="rc-action-btn rc-action-btn--block"
                onClick={() => handleBlockCustomer(customer.id)}
                disabled={customer.status === 'Blocked'}
                title="Block Customer"
              >
                <Ban size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile Cards */}
      <div className="rc-cards-mobile">
        {filteredCustomers.map((customer, index) => (
          <div 
            key={customer.id} 
            className="rc-card"
            style={{ animationDelay: `${index * 0.05}s` }}
          >
            <div className="rc-card-header">
              <div className="rc-avatar" style={{ backgroundColor: customer.color }}>
                {customer.initials}
              </div>
              <div className="rc-card-header-info">
                <span className="rc-card-name">{customer.name}</span>
                <span className="rc-card-email">{customer.email}</span>
              </div>
              <span 
                className="rc-status-badge"
                style={{
                  backgroundColor: STATUS_COLORS[customer.status]?.bg,
                  color: STATUS_COLORS[customer.status]?.color
                }}
              >
                {customer.status}
              </span>
            </div>

            <div className="rc-card-body">
              <p className="rc-card-reason">{customer.reason}</p>
              <div className="rc-card-meta">
                <span className="rc-card-reporter">
                  By {customer.reportedBy}
                </span>
                <span className="rc-card-reports">
                  {customer.reports} reports
                </span>
              </div>
            </div>

            <div className="rc-card-actions">
              <button 
                className="rc-action-btn rc-action-btn--view"
                onClick={() => handleViewDetails(customer.id)}
              >
                <Eye size={14} />
              </button>
              <button 
                className="rc-action-btn rc-action-btn--block"
                onClick={() => handleBlockCustomer(customer.id)}
                disabled={customer.status === 'Blocked'}
              >
                <Ban size={14} />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Empty State */}
      {filteredCustomers.length === 0 && (
        <div className="rc-empty">
          <AlertTriangle size={64} />
          <h3>No reported customers found</h3>
          <p>Try adjusting your search or filters</p>
        </div>
      )}

    </div>
  );
};

export default AdminCustomers;